import { render, staticRenderFns } from "./mdBackHistList.vue?vue&type=template&id=19f04bb8&scoped=true"
import script from "./mdBackHistList.vue?vue&type=script&lang=js"
export * from "./mdBackHistList.vue?vue&type=script&lang=js"
import style0 from "./mdBackHistList.vue?vue&type=style&index=0&id=19f04bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f04bb8",
  null
  
)

export default component.exports